import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogCustomAnnotationDropdownContent from './VeltCommentDialogCustomAnnotationDropdownContent/VeltCommentDialogCustomAnnotationDropdownContent';
import VeltCommentDialogCustomAnnotationDropdownTrigger from './VeltCommentDialogCustomAnnotationDropdownTrigger/VeltCommentDialogCustomAnnotationDropdownTrigger';
import { transformWireframeProps } from '../../../utils/propUtils';
;
var VeltCommentDialogCustomAnnotationDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogCustomAnnotationDropdown.Content = VeltCommentDialogCustomAnnotationDropdownContent;
VeltCommentDialogCustomAnnotationDropdown.Trigger = VeltCommentDialogCustomAnnotationDropdownTrigger;
export default VeltCommentDialogCustomAnnotationDropdown;
